import React from 'react';
import { GenericDetailPage } from '../../components/generic';
import { useVesselOperationType, type VesselOperationType } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => (
  <GenericDetailPage<VesselOperationType>
    useData={useVesselOperationType}
    config={{
      ...moduleConfig,
      getDetailSections,
      getStatusBadges,
    }}
  />
);

export default Detail;
